import React from 'react';
import { ErrorPage } from 'components';

const Page404: React.FC = () => {
  return <ErrorPage type="Error404" />
};

export default Page404;
